import { useState, useCallback } from 'react';

/**
 * Custom hook to manage pagination state and logic
 *
 * @param {number} initialCount - Initial number of items to load (default: 10)
 * @param {number} incrementBy - Number of items to load on each "load more" (default: 10)
 *
 * @returns {object} Pagination state and handlers
 */
export const usePagination = (initialCount = 10, incrementBy = 10) => {
  const [count, setCount] = useState(initialCount);
  const [hasMore, setHasMore] = useState(true);

  const handleLoadMore = useCallback(() => {
    setCount(prevCount => prevCount + incrementBy);
  }, [incrementBy]);

  const resetPagination = useCallback(() => {
    setCount(initialCount);
    setHasMore(true);
  }, [initialCount]);

  const updateHasMore = useCallback((dataLength) => {
    setHasMore(dataLength >= count);
  }, [count]);

  return {
    count,
    hasMore,
    setHasMore,
    handleLoadMore,
    resetPagination,
    updateHasMore,
  };
};

export default usePagination;
